import {
  DialogOffset
} from "./chunk-WOVMNRL4.mjs";
import {
  cn
} from "./chunk-DYSUVPH5.mjs";
import {
  usePreventScroll
} from "./chunk-EO4WTDIV.mjs";

// src/components/modal/modal-container.tsx
import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
var ModalContainer = ({
  isOpen,
  className,
  initialFocusRef,
  children,
  onClose
}) => {
  usePreventScroll({ isDisabled: !isOpen });
  return /* @__PURE__ */ React.createElement(Transition, { appear: true, show: isOpen, as: Fragment }, /* @__PURE__ */ React.createElement(
    Dialog,
    {
      className: cn("fixed inset-0 z-[11] overflow-y-auto", className),
      onClose,
      initialFocus: initialFocusRef,
      static: true
    },
    /* @__PURE__ */ React.createElement(DialogOffset, null),
    /* @__PURE__ */ React.createElement("div", { className: "js-dialog-offset flex items-center justify-center min-h-fill-available" }, /* @__PURE__ */ React.createElement(
      Transition.Child,
      {
        as: Fragment,
        enter: "transition ease-out duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "transition ease-in duration-300",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0"
      },
      /* @__PURE__ */ React.createElement(Dialog.Overlay, { className: "fixed inset-0 bg-black/50" })
    ), /* @__PURE__ */ React.createElement(
      Transition.Child,
      {
        as: Fragment,
        enter: "transition ease-out duration-300",
        enterFrom: "opacity-0 translate-y-8",
        enterTo: "opacity-100 translate-y-0",
        leave: "transition ease-in duration-300",
        leaveFrom: "opacity-100 translate-y-0",
        leaveTo: "opacity-0 translate-y-8"
      },
      /* @__PURE__ */ React.createElement("div", { className: "relative flex items-center justify-center" }, children)
    ))
  ));
};

export {
  ModalContainer
};
